export const GET_COMPARISON_PRODUCTS_REQUEST = 'GET_COMPARISON_PRODUCTS_REQUEST';
export const GET_COMPARISON_PRODUCTS_SUCCESS = 'GET_COMPARISON_PRODUCTS_SUCCESS';
export const GET_COMPARISON_PRODUCTS_FAILURE = 'GET_COMPARISON_PRODUCTS_FAILURE';
export const ADD_COMPARISON_PRODUCT = 'ADD_COMPARISON_PRODUCT';
export const REMOVE_COMPARISON_PRODUCT = 'REMOVE_COMPARISON_PRODUCT';
export const REMOVE_ALL_COMPARISON_PRODUCTS = 'REMOVE_ALL_COMPARISON_PRODUCTS';
export const SET_INITIAL_COMPARISON_STATE = 'SET_INITIAL_COMPARISON_STATE';
export const SET_COMPARISON_ORDER_PRODUCTS = 'SET_COMPARISON_ORDER_PRODUCTS';
